import { Instagram, MapPin, Phone, Clock, MessageCircle } from "lucide-react";
import { PIKKO } from "../../lib/pikko";
import PikkoLogo from "../PikkoLogo";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative pt-20 pb-10"
      style={{
        background:
          "linear-gradient(180deg, var(--pikko-footer-from) 0%, var(--pikko-footer-to) 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <PikkoLogo size={46} color="#EF6F2C" />
              <div>
                <div className="font-serif text-[24px] text-[var(--pikko-cream)] tracking-tight font-semibold">
                  PIKKO<span className="text-[var(--pikko-orange)]">.</span>{" "}
                  Pet Care
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--pikko-cream)]/55 font-medium">
                  Compassionate Care · Happy Pets
                </div>
              </div>
            </div>
            <p className="mt-7 max-w-md text-[14.5px] leading-relaxed text-[var(--pikko-cream)]/90">
              <span className="italic">"We Care, They Deserve."</span> Praktek
              Dokter Hewan di Jatiasih Bekasi dengan layanan poliklinik, rawat
              inap, emergency care, pet hotel, grooming, dan layanan exotic.
            </p>

            <a
              href={PIKKO.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-btn"
              className="mt-8 inline-flex items-center gap-2.5 px-5 py-3 rounded-full bg-[var(--pikko-orange)] text-white text-sm font-medium hover:bg-[var(--pikko-orange-dark)] transition-colors duration-300"
            >
              <MessageCircle className="w-4 h-4" /> Book via WhatsApp
            </a>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[var(--pikko-cream)]/75 font-semibold">
              Contact &amp; Visit
            </div>
            <div className="mt-6 space-y-5">
              <div className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[var(--pikko-orange)] flex-shrink-0" />
                <p className="text-[13.5px] text-[var(--pikko-cream)]/95 leading-relaxed">
                  {PIKKO.address}
                </p>
              </div>
              <div className="flex gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[var(--pikko-orange)] flex-shrink-0" />
                <p className="text-[13.5px] text-[var(--pikko-cream)]/95">
                  {PIKKO.whatsappNumber}
                </p>
              </div>
              <div className="flex gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-[var(--pikko-orange)] flex-shrink-0" />
                <p className="text-[13.5px] text-[var(--pikko-cream)]/95">
                  {PIKKO.hours}
                </p>
              </div>
              <div className="flex gap-3">
                <Instagram className="w-4 h-4 mt-0.5 text-[var(--pikko-orange)] flex-shrink-0" />
                <a
                  href={PIKKO.instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[13.5px] text-[var(--pikko-cream)]/95 hover:text-[var(--pikko-orange)] transition-colors"
                  data-testid="footer-instagram-link"
                >
                  {PIKKO.instagram}
                </a>
              </div>
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[var(--pikko-cream)]/75 font-semibold">
              Layanan
            </div>
            <ul className="mt-6 space-y-3">
              {[
                ["Poliklinik", "#poliklinik"],
                ["Rawat Inap", "#rawat-inap"],
                ["Pet Hotel", "#rawat-inap"],
                ["Pet Grooming", "#grooming"],
                ["Lokasi", "#lokasi"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="text-[13.5px] text-[var(--pikko-cream)]/95 hover:text-[var(--pikko-orange)] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href={PIKKO.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 inline-block text-[12px] uppercase tracking-[0.22em] text-[var(--pikko-orange)] font-semibold hover:text-white transition-colors"
              data-testid="footer-maps-link"
            >
              Open in Google Maps →
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[rgba(246,241,232,0.18)] flex flex-col sm:flex-row gap-3 justify-between items-center">
          <p className="text-[12px] text-[var(--pikko-cream)]/75">
            © {new Date().getFullYear()} Pikko Pet Care · All rights reserved.
          </p>
          <p className="text-[11px] text-[var(--pikko-cream)]/65 tracking-wide">
            Crafted with care for pets in Jatiasih, Bekasi.
          </p>
        </div>
      </div>
    </footer>
  );
}
